import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CULTURE_ROUTE_PARAM, CultureKeyType, FALLBACK_CULTURE } from '@constants/app.constants';
import { LetDirective } from '@directives/app-let.directive';
import { SearchWidgetCopy } from '@models/cms/search-widget.model';
import { GrowthBookFeatureKeys } from '@models/growthbook.models';
import { Store } from '@ngrx/store';
import { selectShowModifySearchWidget } from '@selectors/app.selector';
import { selectRouteParam } from '@selectors/router.selector';
import { GrowthBookService } from '@services/growthbook/growthbook.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-search-header',
  standalone: true,
  imports: [
    CommonModule,
    LetDirective,
  ],
  templateUrl: './search-header.component.html',
  styleUrl: './search-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchHeaderComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  
  @Input() cmsCopy: SearchWidgetCopy;

  isModifyWidget$ = this.store.select(selectShowModifySearchWidget);
  culture$ = this.store.select(
    selectRouteParam(CULTURE_ROUTE_PARAM)
  ) as Observable<CultureKeyType | undefined>;

  readonly gbf = GrowthBookFeatureKeys;
  readonly FALLBACK_CULTURE = FALLBACK_CULTURE;

  constructor(
    public store: Store,
    public gbs: GrowthBookService,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.initGrowthBookChangeDetection();
  }

  private initGrowthBookChangeDetection(): void {
    this.gbs.onChange$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.cd.detectChanges();
      });
  }
}
